import types from "cms/enums/contentsTypes.enum";
export var codeBlockText = {
    label: "code block text",
    type: types.CODE_BLOCK_TEXT,
    value: ""
};
